/**
 * @namespace {BX.UI}
 */
export default class AirButtonStyle
{
	static FILLED = '--style-filled';
	static FILLED_WHITE = '--style-filled-white';
	static FILLED_BITRIX_GPT = '--style-filled-bitrix-gpt';
	static TINTED = '--style-tinted';
	static TINTED_ALERT = '--style-tinted-alert';
	static TINTED_BITRIX_GPT = '--style-tinted-bitrix-gpt';
	static OUTLINE_ACCENT_1 = '--style-outline-accent-1';
	static OUTLINE_ACCENT_2 = '--style-outline-accent-2';
	static OUTLINE = '--style-outline';
	static OUTLINE_NO_ACCENT = '--style-outline-no-accent';
	static OUTLINE_BITRIX_GPT = '--style-outline-bitrix-gpt';
	static PLAIN_ACCENT = '--style-plain-accent';
	static PLAIN = '--style-plain';
	static PLAIN_NO_ACCENT = '--style-plain-no-accent';
	static SELECTION = '--style-selection';
	static FILLED_COPILOT = '--style-filled-copilot';
	static FILLED_SUCCESS = '--style-filled-success';
	static FILLED_ALERT = '--style-filled-alert';
	static FILLED_BOOST = '--style-filled-boost';
}
